// extracted by mini-css-extract-plugin
export default {"shortTermLoanTable":"ShortTermLoanPlan_shortTermLoanTable__r9O2i"};